"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PhotoIcon;
var _react = _interopRequireDefault(require("react"));
var _iconBase = _interopRequireDefault(require("./shared/icon-base"));
var _core = require("@emotion/core");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function PhotoIcon(props) {
  return (0, _core.jsx)(_iconBase.default, props, (0, _core.jsx)("path", {
    d: "M1 3V21H23V3H1ZM21 5V14.5619C19.1849 13.7527 16.53 13.3621 13.8257 14.9641C12.3267 13.4157 10.5868 12 8.20019 12C5.91558 12 4.22369 13.4037 2.99999 14.7942V5H21ZM3 19V18.0195C3.11591 17.8713 3.23871 17.7101 3.37402 17.5293C4.42968 16.124 6.0249 14 8.20019 14C10.2681 14 11.7793 15.6572 13.3789 17.4131C13.8746 17.9569 14.3785 18.5001 14.9031 19H3ZM19 19C17.6679 19 16.4733 17.8232 15.235 16.4777C17.8632 15.1532 20.1434 16.2859 21 16.8384V19H19ZM14 10C14 8.89539 14.8954 8 16 8C17.1045 8 18 8.89539 18 10C18 11.1046 17.1045 12 16 12C14.8954 12 14 11.1046 14 10Z",
    fill: "currentColor"
  }));
}